import styled from 'styled-components';
import { animated } from 'react-spring';
import { _DivProps } from 'styles/base';

export const Container = styled(animated.div)<_DivProps>``;

export const Wrapper = styled(animated.div)<_DivProps>``;
